import { createStore } from 'vuex';

export default createStore({
  state: {
    chatType: 'file',
    chatHistory: [],
    newMessage: '',
    dbKey: null,
    localPdfUrl: null,
    sql: null
  },
  mutations: {
    SET_CHAT_TYPE(state, type) {
      state.chatType = type;
      state.chatHistory = [];
      state.dbKey = null;

      if (type === 'file') {
        state.chatHistory.push({
          from: 'bot',
          type: 'text',
          text: 'Necesitas cargar un archivo PDF para empezar a interactuar.'
        });
      }
    },

    RESET_CHAT(state) {
      state.chatHistory = [];
      state.newMessage = '';
      state.localPdfUrl = null;
      state.sql = null;
      state.dbKey = null;

      if (state.chatType === 'file') {
        state.chatHistory.push({
          from: 'bot',
          type: 'text',
          text: 'Necesitas cargar un archivo PDF para empezar a interactuar.'
        });
      }
    },
    SET_MESSAGE(state, message) {
      state.newMessage = message;
    },
    ADD_MESSAGE(state, message) {
      state.chatHistory.push(message);
    },
    SET_DB_KEY(state, key) {
      state.dbKey = key;
    },
    SET_PDF_URL(state, url) {
      state.localPdfUrl = url;
    },
    SET_SQL(state, sql) {
      state.sql = sql;
    }
  },
  actions: {
    changeChatType({ commit }, type) {
      commit('SET_CHAT_TYPE', type);
    },
    resetChat({ commit }) {
      commit('RESET_CHAT');
    },
    addMessage({ commit }, msg) {
      commit('ADD_MESSAGE', msg);
    },
    updateMessage({ commit }, msg) {
      commit('SET_MESSAGE', msg);
    }
  },
  getters: {
    chatType: (state) => state.chatType,
    chatHistory: (state) => state.chatHistory,
    newMessage: (state) => state.newMessage,
    dbKey: (state) => state.dbKey,
    localPdfUrl: (state) => state.localPdfUrl,
    sql: (state) => state.sql
  }
});
